import BasicModal from 'components/Modal'
import SoftBox from 'components/SoftBox'
import SoftButton from 'components/SoftButton'
import SoftTypography from 'components/SoftTypography'
import React from 'react'
import toast from 'react-hot-toast'
import { Link } from 'react-router-dom'
import { baseURL } from 'utils/api'

const ConfirmModal = ({show,unShow,businessId,setRefresh}) => {
  

    const handleSubmit = (businessId) => {  
        fetch(`${baseURL}/profile/markAsDefault?id=${businessId}`, {
            method: "PUT",
            })
            .then((res) => res.json())
            .then((res) => {
                if (res.status) {
                    toast.success(res.message);
                unShow(false);
                setRefresh(2);
                }
            }); 
    }



      
  return (
    <BasicModal show={show} unShow={unShow}>
      
      <SoftBox  display="flex" flexDirection="column" alignItems="center" justifyContent="center" p={2}>  

        <SoftTypography variant="h6" fontWeight="bold" color="text">  
        Are you sure you want to mark as default?
        </SoftTypography>
        {/* <SoftTypography variant="caption" color="info">
          Please read the terms and conditions carefully before accepting the offer.
        </SoftTypography> */}
       
      </SoftBox>
      <SoftBox display="flex" gap={2} mt={2}>
          <SoftButton variant="outlined" color="info" sx={{width:"100%"}} fullWidth onClick={()=>unShow(false)}>
            Cancel
          </SoftButton>
          <SoftButton variant="gradient" color="info" sx={{width:"100%"}} fullWidth onClick={()=>handleSubmit(businessId)}>
          Sure
          </SoftButton>
        </SoftBox>
    </BasicModal>
  )
}

export default ConfirmModal